import { css } from 'lit';

export const styles = css`
  sl-card {
    margin-top: 16px;
  }
`;
